import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import {withRouter} from "react-router-dom";
import IncomeExpenseCategoryTable from "../../components/Tables/IncomeExpenseCategoryTable";
import withPermissions from "../../components/WithPermissions";
import ManagementPageHero from "../../components/ManagementPageHero";
class Categories extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewCategoryExpenseIncomePermission = userPermissions.includes('new expense income category');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Kategoriler"
                Breadcrumb={[
                  {name: "Gelir ve Giderler", navigate: "incomes"},
                  {name: "Kategoriler", navigate: "income-expense-categories"},
                ]}
            />
            <ManagementPageHero
              eyebrow="FİNANS KATEGORİLERİ"
              title="Gelir ve gider kategorilerini düzenleyin"
              description="Finansal hareketlerinizi anlaşılır raporlayabilmek için kategori yapınızı yönetin."
              actionTo={userHasNewCategoryExpenseIncomePermission ? "/income-expense-categories-add" : null}
              actionLabel="Yeni kategori"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card management-list-card">
                  <div className="header">
                    <h2>Kategoriler</h2>
                    {userHasNewCategoryExpenseIncomePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/income-expense-categories-add">Yeni Kategori</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <IncomeExpenseCategoryTable>

                    </IncomeExpenseCategoryTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Categories)));
